import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getThemes } from '../../reducers/portalConfig';
import { Button, CircularProgress, Typography, makeStyles, withStyles, Box, Container } from '@material-ui/core';
import styles from "./styles";
import { registerUser } from '../../actions/registration';
import { checkAllFieldsEmpty, validateSignupOnSubmit, validateSignupOnchange } from './registrationUtils';
import { useIntl } from "react-intl";
import { getI18n } from "../../utils/intl";
import Branding from '../../components/Header/Branding';
import PropTypes from 'prop-types';
import { AlertMessages, FormDialog, FormTextField } from '../../components';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import SliderCaptcha from './Slider';
import { getAlternateLogo } from "../../utils";
import clsx from 'clsx';

export const Registration = (props) => {
  const [registerData, setRegisterData] = useState({
    email: "",
    confirmEmail: "",
    organizationName: "",
    organizationDesc: "",
  });
  const [emailError, setEmailError] = useState('');
  const [confirmEmailError, setConfirmEmailError] = useState('');
  const [signupEmailError, setSignupEmailError] = useState('');
  const [signupConfirmEmailError, setSignupConfirmEmailError] = useState('');
  const [alertErrorMessage, setAlertErrorMessage] = useState('')
  const [sliderError, setSliderError] = useState('');
  const [sliderValue, setSliderValue] = useState(1);
  const [cancelButtonModal, setCancelButtonModal] = useState(false)

  const { registerUser, register, logo, alternateLogo } = props;

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const intl = getI18n(useIntl());

  const handleChange = (value, fieldName) => {
    setRegisterData({ ...registerData, [fieldName]: value });
    validateSignupOnchange(value, fieldName, setEmailError, intl, setConfirmEmailError,
      { ...registerData, [fieldName]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAlertErrorMessage("");

    validateSignupOnSubmit(registerData, setSignupEmailError, setSignupConfirmEmailError,
      registerUser, intl, sliderValue, setSliderError);
  };

  const history = useHistory();
  const location = useLocation();

  const registerSuccessData = register?.data;

  let formValidationError = '';
  let formSubmissionError = '';
  let unKnownError = '';
  let decideFieldError = '';
  if (register?.error[0]) {
    if (register?.error[0]?.error) {
      formValidationError = register?.error[0]?.error;
      decideFieldError = register?.error[0]?.field;
    } else {
      formSubmissionError = register?.error[0]?.response?.data?.error?.message?.value;
      if (!formSubmissionError) {
        unKnownError = intl.getI18nMessage('label.signup.unknown.error');
      }
    }
  }
  const registerLoader = register?.isLoading;

  const isInvalidEmail = emailError && registerData.email !== "";
  const isEmailMandatory = signupEmailError && registerData.email === "";

  const invalidEmail = <span className={classes.textError}>{emailError}</span>;
  const mandatoryEmail = <span className={classes.textError}>{signupEmailError}</span>;
  const emailHelpText = intl.getI18nMessage("label.user.profile.email.length.helpertext");

  const isEmailMatch = confirmEmailError && registerData.confirmEmail !== "";
  const isConfirmEmailMandatory = signupConfirmEmailError && registerData.confirmEmail === "";

  const emailsMustMatch = <span className={classes.textError}>{confirmEmailError}</span>;
  const mandatoryConfirmEmail = <span className={classes.textError}>
    {signupConfirmEmailError}</span>;

  const organizationNameHelpText = intl.getI18nMessage("label.application.details.header.name.helpertext");

  const orgNameFieldClass = clsx(classes.fieldContainer, classes.textFieldSmall,
    classes.orgNameFieldContainer);

  const handleCancelButton = () => {
    const registerDataIsEmpty = checkAllFieldsEmpty(registerData);
    if (!registerDataIsEmpty) {
      setCancelButtonModal(true)
    } else {
      setCancelButtonModal(false);
      history.goBack();
    }
  }

  useEffect(() => {
    if (formSubmissionError) {
      setAlertErrorMessage(formSubmissionError)
    } else if (formValidationError) {
      setAlertErrorMessage(formValidationError);
    } else if (unKnownError) {
      setAlertErrorMessage(unKnownError);
    }

    if (registerSuccessData !== "") {
      const newParams = { 'registration-success': 'true' };

      const updatedSearch = new URLSearchParams(location.search);
      Object.entries(newParams).forEach(([key, value]) => {
        updatedSearch.set(key, value);
      });

      history.replace({
        pathname: '/admin/app/check-your-email',
        search: `?${updatedSearch.toString()}`,
      });
    }
  }, [registerSuccessData, formSubmissionError, formValidationError, unKnownError]);

  return (
    <Fragment>
      <Container className={`${classes.root} ${classes.flexCenter}`}>
        <Box className={classes.loaderContainer}>
          {
            registerLoader && <CircularProgress className={classes.circularProgress} />
          }
        </Box>

        <FormDialog
          isOpen={cancelButtonModal}
          title={intl.getI18nMessage("label.dialog.unsaved.changes.title")}
          cancelText={intl.getI18nMessage("label.cancel.button")}
          submitText={intl.getI18nMessage("label.ok.button")}
          onCancel={() => setCancelButtonModal(false)}
          onSubmit={() => history.goBack()}
        >
          {intl.getI18nMessage("label.dialog.unsaved.changes.description")}
        </FormDialog>

        {alertErrorMessage &&
          <AlertMessages
            variant={"error"}
            message={alertErrorMessage}
            className={classes.alertContainer}
            onClose={() => {
              setAlertErrorMessage("");
            }}
          />
        }

        <Box className={classes.formSection}>
          <Box className={`${classes.flexCenter} ${classes.imgLogo}`}>
            {logo ? <Branding logo={logo} /> : <Typography variant='h1' className={classes.alternateLogo}>
              {alternateLogo}
            </Typography>}
          </Box>
          <Typography
            data-apim-test={'registration-header'}
            variant='h2'
            className={`${classes.textCenter} ${classes.titleRegister}`}
          >
            {intl.getI18nMessage("label.signup.title")}
          </Typography>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Box className={classes.textFieldSmall}>
              <FormTextField
                id="registration-email"
                textFieldClass={classes.formFieldContainer}
                name={intl.getI18nMessage("label.email")}
                handleChange={(value) => handleChange(value, "email")}
                value={registerData.email}
                helperText={isInvalidEmail ? invalidEmail :
                  (isEmailMandatory ? mandatoryEmail : isEmailMatch
                    ? emailsMustMatch : emailHelpText)}
                error={(isInvalidEmail || isEmailMandatory || isEmailMatch || (formValidationError && decideFieldError === "Email")) ? true : false}
                maxLength="254"
              />
            </Box>

            <Box className={`${classes.fieldContainer} ${classes.textFieldSmall}`}>
              <FormTextField
                id="registration-confirm-email"
                textFieldClass={classes.formFieldContainer}
                name={
                  intl.getI18nMessage("label.user.details.confirm.email.title")}
                handleChange={(value) => handleChange(value, "confirmEmail")}
                value={registerData.confirmEmail}
                helperText={isEmailMatch ? emailsMustMatch :
                  (isConfirmEmailMandatory ? mandatoryConfirmEmail : (isInvalidEmail && registerData.confirmEmail !== "") ? invalidEmail : "")}
                error={(isEmailMatch || isConfirmEmailMandatory || (formValidationError && decideFieldError === "Email")) ? true : false}
                maxLength="254"
              />
            </Box>

            <Box className={orgNameFieldClass}>
              <FormTextField
                id="registration-org-name"
                textFieldClass={classes.formFieldContainer}
                optional={true}
                name={intl.getI18nMessage("label.organization.name.list.page.filter.by.name.placeholder")}
                handleChange={(value) => handleChange(value, "organizationName")}
                value={registerData.organizationName}
                helperText={organizationNameHelpText}
                error={(formValidationError && decideFieldError === "OrganizationName") ? true : false}
                maxLength="50"
              />
            </Box>

            <Box className={`${classes.fieldContainer} `}>
              <FormTextField
                id="registration-org-description"
                textFieldClass={classes.formFieldContainer}
                optional={true}
                name={intl.getI18nMessage("label.organization.description")}
                handleChange={(value) => handleChange(value, "organizationDesc")}
                value={registerData.organizationDesc}
                maxLength="255"
                multiline={true}
                rows={5}
                helperText={intl.getI18nMessage("label.application.details.overview.desc.helpertext")}
              />
            </Box>

            <Box className={classes.fieldContainer}>
              <Typography variant='h2' className={classes.captchaTitle}>{intl.getI18nMessage("label.signup.captcha.title")}</Typography>
              <SliderCaptcha
                sliderValue={sliderValue}
                setSliderValue={setSliderValue}
                decideSliderReset={(formValidationError || formSubmissionError) ? true : false}
              />
              <Typography className={classes.textError} variant='subtitle2'>{sliderError && sliderValue !== 100 ? sliderError : ""}</Typography>
            </Box>

            <Box className={classes.signupContainer}>
              <Button
                className={classes.submitButton}
                data-apim-test="signup-submit"
                variant="contained"
                color="secondary"
                type='submit'
              >
                {intl.getI18nMessage("label.custom.pages.select.sign.up")}
              </Button>
            </Box>

            <Box>
              <Button
                className={classes.cancelButton}
                data-apim-test="cancel-submit"
                variant="outlined"
                onClick={() => handleCancelButton()}
              >
                {intl.getI18nMessage("label.cancel.button")}
              </Button>
            </Box>
          </form>
        </Box>
      </Container>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  const { logo, siteTitle } = getThemes(state);

  return {
    register: state?.register,
    logo,
    alternateLogo: getAlternateLogo(siteTitle),
  };
};

const mapDispatchToProps = {
  registerUser,
};

Registration.propTypes = {
  registerUser: PropTypes.func,
  register: PropTypes.object,
  logo: PropTypes.string,
  alternateLogo: PropTypes.string,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Registration);